<agr-page-detail
  [pageTitle]="
    ('template' | translate) + ' (' + ((template$ | async)?.templateType | translate) + ')'
  "
  [isEmpty]="(template$ | async)?.treatments?.length <= 0"
  [emptyTitle]="'treatmentsEmptyTitle' | translate"
  [emptyDescription]="'treatmentsEmpty' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'addTreatment' | translate"
  [stickyToolbar]="true"
  [stickyDetails]="true"
  (primaryAction)="addTreatment()"
  (backAction)="openOverview()"
  [buttonItems]="buttonItems"
  (buttonAction)="buttonAction($event)"
>
  <div details>
    <mat-chip-listbox>
      @if ((template$ | async)?.isPlanetProof) {
        <mat-chip-option selected [selectable]="false">
          {{ 'planetProof' | translate }}
        </mat-chip-option>
      }
      @if ((template$ | async)?.isSkal) {
        <mat-chip-option selected [selectable]="false">
          {{ 'skal' | translate }}
        </mat-chip-option>
      }
      @if ((template$ | async)?.isGroundWaterPreservation) {
        <mat-chip-option selected [selectable]="false">
          {{ 'groundWaterPreservation' | translate }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
    <div class="flex flex--responsive-gt-sm spacing--padding-half-vertical text--small">
      <div class="flex__child--auto spacing--margin-right">
        <span class="text--bold">{{ 'cropYear' | translate }}:</span>
        {{ (template$ | async)?.cropYear }}
      </div>

      <div class="flex__child--auto spacing--margin-right">
        <span class="text--bold">{{ 'crop' | translate }}:</span>
        {{ displayCropName$ | async }}
      </div>

      <div class="flex__child--auto spacing--margin-right">
        <span class="text--bold">{{ 'soilType' | translate }}:</span>
        {{ displaySoilType$ | async }}
      </div>

      <div class="flex__child--auto spacing--margin-right">
        <span class="text--bold">{{ 'province' | translate }}:</span>
        {{ provinces }}
      </div>
    </div>
  </div>

  <div class="container--fixed-height container--page__content">
    <div class="row--container">
      <div class="wrapper--spacing-horizontal">
        @if ((template$ | async)?.treatments?.length > 0) {
          <div class="row">
            <div class="col-5 col-responsive">
              <h3 class="text--h3">{{ 'schemas' | translate }}</h3>
              @if ((template$ | async)?.treatmentSchemas?.length > 0) {
                <h6 class="text--h6 default-crop-advice-header">
                  {{ 'defaultCropAdvice' | translate }}
                </h6>
              }
              <mat-list
                class="layout--margin-negative-horizontal"
                data-test="treatment-schemas-list"
              >
                @if (treatmentSchemas$ | async; as treatmentSchemas) {
                  @for (treatmentSchema of treatmentSchemas; track treatmentSchema.id) {
                    <div>
                      <mat-checkbox
                        color="primary"
                        (change)="setSchemaAsDefault($event.checked, treatmentSchema)"
                        [checked]="selectedCheckboxId === treatmentSchema.id"
                        class="default-schema-checkbox"
                        [disableRipple]="true"
                      >
                      </mat-checkbox>
                      <mat-list-item class="schema-list-item" data-test="treatment-schema-items">
                        <agr-responsive-actions
                          matListItemMeta
                          [items]="treatmentSchemaActions$ | async"
                          [showLabels]="false"
                          (action)="treatmentSchemaAction($event, treatmentSchema)"
                        ></agr-responsive-actions>
                        <mat-icon matListItemIcon>description</mat-icon>
                        <h2 matListItemTitle>{{ treatmentSchema?.name }}</h2>
                        <span matListItemLine>{{ treatmentSchema.description }}</span>
                      </mat-list-item>
                    </div>
                  }
                }
              </mat-list>
              <h3 class="text--h3">{{ 'treatments' | translate }}</h3>
              @if ((areTreatmentsValid$ | async) === false) {
                <div class="notification notification-error">
                  <mat-icon>warning</mat-icon>
                  {{ 'invalidTreatments' | translate }}
                </div>
              }
              <mat-list class="layout--margin-negative-horizontal" data-test="treatments-list">
                @if (treatmentsWithActions$ | async; as treatments) {
                  @for (treatment of treatments; track $index; let i = $index) {
                    @if (treatment.hasDate) {
                      <h3 matSubheader class="spacing--padding-top">
                        {{ 'period' | translate }}
                        {{
                          getSalesOrderPeriod(salesOrderPeriods$ | async, treatment.periodId)?.name
                        }}
                      </h3>
                    }
                    <mat-list-item data-test="treatments-item" class="treatment-container">
                      <agr-responsive-actions
                        matListItemMeta
                        [items]="treatment.actions"
                        [showLabels]="false"
                        (action)="treatmentAction($event, treatment, i)"
                      ></agr-responsive-actions>
                      <div matListItemIcon class="treatment-icon-container">
                        @if (isTreatmentValid(treatment) && treatment.frequency <= 1) {
                          <mat-icon>short_text</mat-icon>
                        }
                        @if (isTreatmentValid(treatment) && treatment.frequency > 1) {
                          <mat-icon>cached</mat-icon>
                        }
                        @if (!isTreatmentValid(treatment)) {
                          <mat-icon color="warn">error</mat-icon>
                        }
                      </div>
                      <h2 matListItemTitle>
                        {{ treatment?.name }}
                        @if (treatment.frequency > 1) {
                          <span
                            >({{ treatment.frequency }}
                            {{ 'amountOfRepetitions' | translate }})</span
                          >
                        }
                      </h2>
                      <span matListItemLine>{{ treatment.objective | translate }}</span>
                      <span matListItemLine>
                        {{ getTreatmentNamesAndDosages$(treatment) | async }}
                      </span>
                      @if (treatment.modifiedByEmployee) {
                        <span matListItemLine>
                          {{ treatment.modifiedByEmployee.firstName }}
                          {{ treatment.modifiedByEmployee.lastName }}
                          @if (treatment.dateModified) {
                            <span>({{ treatment.dateModified | agrDate: 'longDate' }})</span>
                          }
                        </span>
                      }
                    </mat-list-item>
                  }
                }
              </mat-list>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</agr-page-detail>
